App.components.ws_icon = {
	define: function() {
		customElements.define("ws-icon", class extends HTMLElement {
			constructor() {
				super();
				if (this.innerHTML) return;
				let useElem, svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
				let icons = this.getAttribute('name');

				// presets
				if (icons === 'checkbox') icons = 'input-box-blank:input-box-select:input-box-solid-check';
				if (icons === 'radio') icons = 'input-circle-blank:input-circle-select:input-circle-solid-select';

				icons?.split(':').forEach(function (icon) {
					useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use')
					let sprite = '/assets/img/icons/' + (this.dataset.sprite || 'sprite') +'.svg';
					if (this.dataset.sprite === 'color' || this.dataset.sprite === 'social') useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#ico-' + this.dataset.sprite + '-' + icon);
					else useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', sprite + '#' + icon);
					svgElem.appendChild(useElem);
				}, this);
				//const shadowRoot = this.attachShadow({mode: "open"}).appendChild(svgElem.cloneNode(true));
				this.appendChild(svgElem);
			}
		});
	}
}